<script>
import Layout from "../../layouts/main";
import DatePicker from "vue2-datepicker";
import appConfig from "@/app.config";
import ExportButton from "@/components/export-button";
import axios from "@/axios";
import moment from 'moment';
import DPConfig from "../../../components/dataPickerConf";

export default {
  page: {
    title: "Mis Cotizaciones",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    DatePicker,
    "export-button": ExportButton,
  },
  props: {
    query: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      lang: {
        formatLocale: DPConfig.formatLocale
      },
      fields: [
        {
          key: "numero",
          label: "Nro. Cotizacion",
          sortable: true,
        },
        {
          key: "fechaDesde",
          label: "Fecha retiro",
          sortable: true,
        },
        {
          key: "fechaHasta",
          label: "Fecha devolucion",
          sortable: true,
        },
        {
          key: "sucursalSalida",
          label: "Sucursal retiro",
          sortable: true,
        },
        {
          key: "numeroReserva",
          label: "Reserva",
          sortable: true,
        },
      ],
      tableData: [],
      daterange: [new Date("2000-01-01"), new Date()],
      currentPage: 1,
      perPage: 1,
      pageOptions: [1, 3, 10, 25, 50, 100],    
      totRegistros: 1,  
      isBusy: false,
      type: "cotizaciones",
      inputNumero: "",
    };
  },
  beforeMount(){
    this.getCotizaciones();
  },
  methods: {
    getCotizaciones() {
      this.isBusy = true;
      let data;
      if (this.inputNumero){
        data = {
          rut: parseInt(this.$store.getters["auth/contacto"].identificador),
          numero: this.inputNumero,
          dv: "6",
          fechaDesde: this.daterange[0] ? moment(this.daterange[0]).format('YYYY-MM-DD') : moment(new Date("2000-01-01")).format('YYYY-MM-DD'),
          fechaHasta: this.daterange[1] ? moment(this.daterange[1]).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
          pagina: this.currentPage,
          registros: this.perPage
        };
      }else{
        data = {
          rut: parseInt(this.$store.getters["auth/contacto"].identificador),
          dv: "6",
          fechaDesde: this.daterange[0] ? moment(this.daterange[0]).format('YYYY-MM-DD') : moment(new Date("2000-01-01")).format('YYYY-MM-DD'),
          fechaHasta: this.daterange[1] ? moment(this.daterange[1]).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
          pagina: this.currentPage,
          registros: this.perPage
        };
      }      
      axios
        .post("/GetCotizaciones", data)
        .then((cotizacion) => {
          this.tableData = cotizacion.data.datos
          this.totRegistros = cotizacion.data.totalRegistros;
          this.isBusy = false;
        })
        .catch(() => {
          this.$bvToast.toast(
            this.$t("lease.request.error.message").toString(),
            {
              title: this.$t("lease.request.error.nonFound").toString(),
              variant: "danger",
              solid: true,
            }
          );
          this.isBusy = false;
        });
    },
    buscarNumero(){
      this.getCotizaciones();
    }
  },
  watch:{
    currentPage(){
      this.getCotizaciones();   
    }
  }
};
</script>
<template>
  <Layout>
    <div classs="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center">
              <h4 class="card-tittle">Mis Cotizaciones</h4>
              <export-button :data="tableData" :fileName="type" />
            </b-row>
            <b-row>
              <b-col sm="12" md="6" lg="3">
                <b-form-group label="Número" label-for="formrow-name-input">
                  <b-form-input 
                    type="number"
                    id="formrow-name-input" 
                    v-on:keyup.enter="buscarNumero"
                    v-model="inputNumero">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6" lg="6" offset-lg="3">
                <b-form-group
                  label="Rango de fechas"
                  label-for="formrow-name-input"
                >
                  <date-picker
                    v-model="daterange"
                    range
                    append-to-body
                    :lang="lang"
                    confirm
                    format="DD-MM-YYYY"
                    @change="getCotizaciones"
                  ></date-picker>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="container">
              <b-table 
              :items="tableData"
              :fields="fields"
              :current-page="currentPage"
              :busy="isBusy">

                <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <!-- Fin Spinner en estado "ocupado" de la tabla -->

                <!-- <template #cell(descarga)="row">
                  <b-button variant="danger">
                    <i
                      class="bx bx-download font-size-16 align-middle mr-2"
                    ></i>
                    Descargar
                  </b-button>
                </template> -->

                <template #cell(numero)="row">
                  <router-link
                  :to="{ name: 'detalleCotizacion', params: { id: row.value }}"
                  target="_blank">
                    {{row.value}}
                  </router-link>
                  
                </template>
                <template #cell(numeroReserva)="row">                  
                  <router-link 
                  :to="{ name: 'detalleReserva', params: { id: row.value }}"
                  target="_blank">
                    {{row.value}}
                  </router-link>
                </template>

                <template #cell(fechaDesde)="row">
                  {{ row.value.slice(0, 10) }}
                </template>

                <template #cell(fechaHasta)="row">
                  {{ row.value.slice(0, 10) }}
                </template>

              </b-table>
            </div>

            <!-- Inicio Paginación -->
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    class="portal"
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totRegistros"
                  ></b-pagination>
                </ul>
              </div>
            </div>
            <!-- Fin Paginación -->
            <!-- Inicio Cantidad registros -->
            <!-- <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Mostrar&nbsp;
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select
                  >&nbsp;entries
                </label>
              </div>
            </div> -->
            <!-- Fin Cantidad Registros -->

          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>